import { replaceWords } from "../services/filter-value";

(() => {
  const constants = {
    UPSELL_CART_UPDATE_EVENT: 'lcu:smart-cart:updated',
    PROTECTION_ITEM_WORDS: ['protection'],
    CART_UPDATED: 'upsell:cart-updated',
  }

  const elementSelectors = {
    wrapper: ".lcu__drawer__cart-items",
    line: ".lcu__drawer__item",
    quantityEl: ".lcu__drawer__input-wrapper",
    title: ".lcu__drawer__item-title",
    bubble: "[data-cart-indicator]"
  }

  const updateItemTitles = (items, titleSelector) => {
    items?.forEach((item) => {
      const titleEl = item.querySelector(titleSelector);
      if (titleEl) {
        const updatedTitle = replaceWords(titleEl.textContent);
        titleEl.textContent = updatedTitle;

        if (constants.PROTECTION_ITEM_WORDS.some(word => updatedTitle.toLowerCase().includes(word))) {
          const quantityEl = item.querySelector(elementSelectors.quantityEl);
          quantityEl?.remove();
        }
      }
    });
  }

  const onCartUpdated = () => {
    const cartItems = document.querySelector(elementSelectors.wrapper)?.querySelectorAll(elementSelectors.line);
    updateItemTitles(cartItems, elementSelectors.title);
  }

  const onProductAdded = (event) => {
    const { item_count: itemsCount } = event.detail.newCart;
    document.querySelectorAll(elementSelectors.bubble)?.forEach(indicator => {
      indicator.textContent = itemsCount;
    });
  }

  const onDocumentDownloaded = () => {
    document.addEventListener(constants.UPSELL_CART_UPDATE_EVENT, onCartUpdated);
    document.addEventListener(constants.CART_UPDATED, onProductAdded);
  }

  document.addEventListener('DOMContentLoaded', onDocumentDownloaded);
})();
